export const AppleAppSiteAssociation = (app) => {
  app.get(
    "/.well-known/apple-app-site-association",
    ({ req, res, locals }, next) => {
      return (res.body = {
        applinks: {
          apps: [],
          details: [
            {
              appIDs: [
                "6TSU7742HP.com.mystrengthbook",
                "JTD5Y94S56.com.mystrengthbook",
              ],
              paths: ["*"],
            },
          ],
        },
      });
    }
  );
};
